import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaTrainingApi } from '../api/trainings/CharismaTrainingApi.tsx';
import CharismaCertificationItemForm from './certificationItemForm.tsx';
import { CharismaUserContext } from '../context.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import {formatDate} from '../utils.tsx'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaCertificationItemsList(props){
        
    const [currentItem, setCurrentItem] = React.useState(null);
    const [create, setCreate] = React.useState(false);
    const [itemsList, setItemsList] = React.useState([]);
    const [deleteItems, setDeleteItems] = React.useState(false);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const lCurrentUser = React.useContext(CharismaUserContext);
    const lReadWrite = lCurrentUser !== null && lCurrentUser !== undefined && lCurrentUser.profile === 0;
    const lRunning = props.running


    React.useEffect(()=>{
        const lResponseItems = CharismaTrainingApi.ListCertificationItems(props.trainingId);
        lResponseItems.then((value)=>{
            if(value.error === 0){
                setItemsList(value.certificationItems);
            }
        }).catch((error)=>{
            
        })

    }, [props.trainingId])
    
    function handleCancel(){
        setCreate(false);
    }
    
    function handleDeleteItems(){
        const lResponse = CharismaTrainingApi.DeleteCertificationItems(selectedItems);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.ids !== null){
                    const lIds = value.ids;
                    let lNewItems = itemsList.filter((lItem)=>lIds.indexOf(lItem.id) === -1);
                    setItemsList(lNewItems);   
                    setDeleteItems(false);
                    setSelectedItems([]);                      
                }
;            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })           
    }    
       
    function handleCreateItem(pTitle : string){
        const lResponse = CharismaTrainingApi.CreateCertificationItem(pTitle, props.trainingId);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.item !== null){
                    let lItems = itemsList.concat(value.certificationItem);
                    setItemsList(lItems);
                    setCreate(false);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    }    
    function handleUpdateItem(pTitle : string, pId : number){
        const lResponse = CharismaTrainingApi.UpdateCertificationItem(pTitle, pId);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.certificationItem !== null){
                    const lItems = itemsList.map((lItem)=>lItem.id !== value.certificationItem.id ? lItem : value.certificationItem);
                    setItemsList(lItems);
                    setCurrentItem(null);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    }       
    
    
    function handleSelectedItem(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selectedItems.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selectedItems, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selectedItems.slice(1));
            }
            else if(lIndex === selectedItems.length - 1){
                lNewSelected = lNewSelected.concat(selectedItems.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selectedItems.slice(0, lIndex), selectedItems.slice(lIndex + 1),);
            }
        }
        setSelectedItems(lNewSelected);
    }

    
    function handleSubmit(pTitle : string){
        handleCreateItem(pTitle);

    }
    
    function handleUpdate(pTitle : string, pId: number){
        handleUpdateItem(pTitle, pId);        
    }
    
    function handleCancelUpdate(){
        setCurrentItem(null);
    }
    
    function handleEdit(pId : number){
        const lResponse = CharismaTrainingApi.GetCertificationItem(pId);
        lResponse.then((value)=>{
            if(value.error === 0){
                setCurrentItem(value.certificationItem);
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })  
    }
    

    
    function createItemsTable(pItems : object[], pSelected : number[]){
        return(
            pItems.map((item)=>(
                <TableRow key={item.id}>
                    {lReadWrite && lRunning?
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={pSelected.indexOf(item.id) >= 0}
                                onClick={                                    
                                    (event)=>handleSelectedItem(event, item.id)
                                }
                            />
                        </TableCell>
                        :
                        null
                    }
                    <TableCell>
                        {item.title}
                    </TableCell>
                    
                    {lReadWrite && lRunning?
                        <TableCell padding="checkbox">
                            <IconButton
                                onClick={()=>handleEdit(item.id)}
                            >
                                <EditIcon/>
                            </IconButton>
                        </TableCell>
                        :
                        null
                    }
                </TableRow>
                 
            ))
        )
    }
    
    
    return(
        
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Card>
                        <CardHeader
                            title="Items de certification"
                            action={
                                <div>
                                    {lReadWrite && lRunning?
                                        <div>
                                            <IconButton onClick={()=>setCreate(true)}>
                                                <AddIcon/>
                                            </IconButton>
                                        </div>
                                        :
                                        null
                                    }
                                    {selectedItems.length > 0 && lRunning?
                                        <IconButton onClick={()=>setDeleteItems(true)}>
                                            <DeleteIcon/>
                                        </IconButton>  
                                        :
                                        null
                                    } 
                                </div>
                            }
                        />
                        <CardContent>
                            <Table>                               
                                <TableHead>
                                    <TableRow>
                                        {lReadWrite && lRunning?
                                            <TableCell padding="checkbox">
                                                </TableCell>
                                              :
                                              null
                                        }
                                        <TableCell>Titre</TableCell>
                                        {lReadWrite && lRunning?
                                            <TableCell padding="checkbox">
                                            </TableCell>
                                              :
                                              null
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    createItemsTable(itemsList, selectedItems, false)
                                }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {create ?
                <CharismaCertificationItemForm
                    handleSubmit={handleCreateItem}
                    handleCancel={handleCancel}
                />
                :
                null    
            }    
            {
                currentItem !== null ?
                <CharismaCertificationItemForm
                    handleSubmit={handleUpdate}
                    handleCancel={handleCancelUpdate}                
                    title={currentItem.title}
                    id={currentItem.id}

                />
                :
                null
            }

            <Dialog
                open={deleteItems}
            >
                <DialogTitle>Suppression</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement les items sélectionnés?</Typography>
                    {
                        false?
                            <Alert severity='info'>Suppression en cours...</Alert>
                        :
                        null
                    }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteItems(false)}>
                        Annuler
                    </Button>
                    <Button onClick={handleDeleteItems}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>           
        </Box>      
    );
    
    
}